import { QuestionnairePage } from "./QuestionnairePage";

export default QuestionnairePage;
